import api from './api';

// --- Settings ---
export const getFollowUpTargetExpired = () => api.get('settings/follow-up-target-expired');
export const updateFollowUpTargetExpired = (data: any) => api.put('settings/follow-up-target-expired', data);
